<template>
    <div class="card">
        <div class="card-body">
            <form class="row" @submit.prevent="submitUserDataHandler">
                <div class="form-group col-12">
                    <label for="email">Email</label>
                    <input
                        id="email"
                        v-model="user.email"
                        :class="{
                            'is-invalid': $v.user.email.$error || isEmailTaken
                        }"
                        class="form-control"
                        type="text"
                        @input="isEmailTaken = false"
                    />
                    <div v-if="isEmailTaken" class="invalid-feedback">
                        Email already taken!
                    </div>
                </div>
                <div class="form-group col-12">
                    <label for="firstName">First Name</label>
                    <input
                        id="firstName"
                        v-model="user.firstName"
                        :class="{
                            'is-invalid': $v.user.firstName.$error
                        }"
                        class="form-control"
                        type="text"
                    />
                </div>
                <div class="form-group col-12">
                    <label for="lastName">Last Name</label>
                    <input
                        id="lastName"
                        v-model="user.lastName"
                        :class="{
                            'is-invalid': $v.user.lastName.$error
                        }"
                        class="form-control"
                        type="text"
                    />
                </div>
                <div class="form-group col-12">
                    <label for="nickname">Nickname</label>
                    <input
                        id="nickname"
                        v-model="user.nickname"
                        :class="{
                            'is-invalid': $v.user.nickname.$error
                        }"
                        class="form-control"
                        type="text"
                    />
                </div>
                <div class="col-12">
                    <button
                        type="submit"
                        class="btn btn-success waves-effect waves-light"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
    validations: {
        user: {
            email: {
                required,
                email
            },
            firstName: {
                minLength: minLength(2)
            },
            lastName: {
                minLength: minLength(2)
            },
            nickname: {
                minLength: minLength(2)
            }
        }
    },

    data() {
        return {
            user: {},
            isEmailTaken: false
        };
    },

    computed: {
        ...mapGetters({
            loggedUser: 'auth/loggedUser'
        })
    },

    created() {
        this.user = {
            email: this.loggedUser.email,
            firstName: this.loggedUser.firstName,
            lastName: this.loggedUser.lastName,
            nickname: this.loggedUser.nickname
        };
    },

    methods: {
        ...mapActions({
            updateProfile: 'auth/updateProfile'
        }),

        async submitUserDataHandler() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.updateProfile(this.user);

                this.$toaster('Account has been updated!');
            } catch (err) {
                console.error(err);

                const { response } = err;

                if (response && response.status === 400) {
                    if (response.data.errors.some(e => e.param === 'email')) {
                        this.isEmailTaken = true;
                    }
                } else {
                    this.$toasterError();
                }
            }
        }
    }
};
</script>
